import "./StickerBook.css";

import React, { useState } from "react";
// import { Sparkles, BookOpen } from "lucide-react";

// --- CONFIGURATION & DATA ---

const SPRITE_SHEET_URL =
  "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsticker-book%2Fanimal-stickers-1.webp?alt=media&token=b257e334-7907-4b65-8dbc-df144a20ca88";

const SHEET_WIDTH = 1000;
const SHEET_HEIGHT = 1000;

const STICKERS_DATA = [
  {
    id: 1,
    word: "Monkey",
    rarity: "common",
    bgX: -19,
    bgY: -10,
    bgSize: 620,
    x: -1,
    y: 0,
    width: 130,
    height: 125,
  },
  {
    id: 2,
    word: "Hippo",
    rarity: "common",
    bgX: -190,
    bgY: -20,
    bgSize: 550,
    x: 35,
    y: 0,
    width: 180,
    height: 138,
  },
  {
    id: 3,
    word: "Duck",
    rarity: "common",
    bgX: -380,
    bgY: -10,
    bgSize: 560,
    x: 60,
    y: 10,
    width: 174,
    height: 170,
  },

  {
    id: 4,
    word: "Bear",
    rarity: "common",
    bgX: -10,
    bgY: -230,
    bgSize: 560,
    x: 28,
    y: 23,
    width: 180,
    height: 120,
  },
  {
    id: 5,
    word: "Cow",
    rarity: "common",
    bgX: -180,
    bgY: -175,
    bgSize: 500,
    x: 0,
    y: 55,
    width: 190,
    height: 150,
  },

  {
    id: 6,
    word: "Cat",
    rarity: "common",
    bgX: -400,
    bgY: -192,
    bgSize: 650,
    x: 0,
    y: 27,
    width: 150,
    height: 155,
  },

  {
    id: 7,
    word: "Duckling",
    rarity: "common",
    bgX: -20,
    bgY: -370,
    bgSize: 650,
    x: 65,
    y: 35,
    width: 150,
    height: 155,
  },
  {
    id: 8,
    word: "Penguin",
    rarity: "common",
    bgX: -190,
    bgY: -355,
    bgSize: 550,
    x: 55,
    y: 60,
    width: 180,
    height: 165,
  },
  {
    id: 9,
    word: "Koala",
    rarity: "common",
    bgX: -387,
    bgY: -368,
    bgSize: 550,
    x: 35,
    y: 41,
    width: 180,
    height: 165,
  },
  {
    id: 10,
    word: "Turtle",
    rarity: "common",
    bgX: -30,
    bgY: -545,
    bgSize: 550,
    x: 5,
    y: 70,
    width: 180,
    height: 130,
  },
  {
    id: 11,
    word: "Crab",
    rarity: "common",
    bgX: -215,
    bgY: -543,
    bgSize: 550,
    x: 5,
    y: 50,
    width: 180,
    height: 120,
  },

  {
    id: 12,
    word: "Pig",
    rarity: "common",
    bgX: -25,
    bgY: -675,
    bgSize: 550,
    x: 5,
    y: 50,
    width: 180,
    height: 140,
  },
  {
    id: 13,
    word: "Sheep",
    rarity: "common",
    bgX: -205,
    bgY: -630,
    bgSize: 550,
    x: 5,
    y: 50,
    width: 170,
    height: 140,
  },
  {
    id: 13,
    word: "Dolphin",
    rarity: "common",
    bgX: -350,
    bgY: -505,
    bgSize: 550,
    x: 5,
    y: 50,
    width: 160,
    height: 200,
  },
  {
    id: 14,
    word: "Giraffe",
    rarity: "common",
    bgX: -440,
    bgY: -9,
    bgSize: 550,
    x: 5,
    y: 50,
    width: 140,
    height: 210,
  },

  {
    id: 15,
    word: "Crocodile",
    rarity: "common",
    bgX: -753,
    bgY: -5,
    bgSize: 540,
    x: 5,
    y: 50,
    width: 180,
    height: 160,
  },
  {
    id: 16,
    word: "Fish",
    rarity: "common",
    bgX: -820,
    bgY: -189,
    bgSize: 660,
    x: 5,
    y: 50,
    width: 160,
    height: 110,
  },
  {
    id: 17,
    word: "Cow",
    rarity: "common",
    bgX: -522,
    bgY: -280,
    bgSize: 480,
    x: 5,
    y: 50,
    width: 190,
    height: 140,
  },
  {
    id: 18,
    word: "Lion",
    rarity: "common",
    bgX: -689,
    bgY: -272,
    bgSize: 550,
    x: 5,
    y: 50,
    width: 160,
    height: 145,
  },

  {
    id: 19,
    word: "Duckling",
    rarity: "common",
    bgX: -550,
    bgY: -430,
    bgSize: 750,
    x: 5,
    y: 50,
    width: 120,
    height: 145,
  },
  {
    id: 20,
    word: "Polar Bear",
    rarity: "common",
    bgX: -560,
    bgY: -358,
    bgSize: 570,
    x: 5,
    y: 50,
    width: 130,
    height: 130,
  },
  {
    id: 21,
    word: "Tiger",
    rarity: "common",
    bgX: -455,
    bgY: -502,
    bgSize: 550,
    x: 5,
    y: 50,
    width: 140,
    height: 135,
  },
  {
    id: 22,
    word: "Horse",
    rarity: "common",
    bgX: -605,
    bgY: -505,
    bgSize: 590,
    x: 5,
    y: 50,
    width: 130,
    height: 130,
  },
  {
    id: 22,
    word: "Horse",
    rarity: "common",
    bgX: -605,
    bgY: -505,
    bgSize: 590,
    x: 5,
    y: 50,
    width: 130,
    height: 130,
  },
  {
    id: 23,
    word: "Mouse",
    rarity: "common",
    bgX: -35,
    bgY: -655,
    bgSize: 790,
    x: 5,
    y: 50,
    width: 100,
    height: 130,
  },
  {
    id: 24,
    word: "Frog",
    rarity: "common",
    bgX: -160,
    bgY: -680,
    bgSize: 625,
    x: 5,
    y: 50,
    width: 130,
    height: 120,
  },
  {
    id: 25,
    word: "Chicken",
    rarity: "common",
    bgX: -320,
    bgY: -678,
    bgSize: 625,
    x: 5,
    y: 50,
    width: 130,
    height: 122,
  },

  {
    id: 26,
    word: "Bird",
    rarity: "common",
    bgX: -365,
    bgY: -518,
    bgSize: 625,
    x: 5,
    y: 50,
    width: 100,
    height: 100,
  },
  {
    id: 27,
    word: "Chicken",
    rarity: "common",
    bgX: -590,
    bgY: -638,
    bgSize: 590,
    x: 5,
    y: 50,
    width: 130,
    height: 122,
  },
];

// --- CSS STYLES ---
// Using a template string for standard CSS to keep the file self-contained

// --- COMPONENTS ---

const Sticker = ({ data, isLocked = true, isSelected = false, onClick }) => {
  // Sprite Sheet Percentage Logic
  const bgSizeX = data.bgWidth * 2.8;
  const bgSizeY = data.bgHeight * 2.8;
  const xPercent = data.bgSizeX;
  const yPercent = data.bgSizeY;

  // Determine classes
  let classes = `sticker-card`;
  if (isLocked) classes += " locked";
  if (isSelected) classes += " selected";

  // Rarity classes (only if not locked)
  if (!isLocked) {
    if (data.rarity === "common") classes += " border-common";
    if (data.rarity === "rare") classes += " border-rare";
    if (data.rarity === "legendary") classes += " border-legendary";
  }

  return (
    <div
      className={classes}
      onClick={onClick}
      style={{
        width: `${data.width}px`,
        height: `${data.height}px`,
        position: "absolute",
        left: data.x + 20,
        top: data.y + 20,
        backgroundColor: "red",
      }}
    >
      <div
        className="sticker-image"
        style={{
          backgroundImage: `url(${SPRITE_SHEET_URL})`,
          backgroundPosition: `${xPercent}% ${yPercent}%`,
          backgroundSize: `${bgSizeX}% ${bgSizeY}%`,
        }}
      />
      {/* Legendary Effect */}
      {data.rarity === "legendary" && !isLocked && (
        <div className="legendary-effect" />
      )}
    </div>
  );
};

const StickerSlot = ({ sticker, placedId }) => {
  const isPlaced = placedId !== null;

  return (
    <div className="slot-filled">
      <Sticker data={sticker} />

      {/* Rarity Indicator Dot for Empty Slots */}
      {!isPlaced && <div className={`rarity-dot dot-${sticker.rarity}`} />}
    </div>
  );
};

export const StickerPage = ({ pageIndex }) => {
  const [inventory, setInventory] = useState([]);
  const [placedStickers, setPlacedStickers] = useState([1, 2, 3]);
  const [selectedStickerId, setSelectedStickerId] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);

  // -- LOGIC --

  return (
    <>
      <div className="page-app-container">
        <header className="page-header">
          {pageIndex % 2 === 0 && (
            <div>
              <h1 className="header-title">
                {/* <BookOpen size={24} color="#166534" /> */}
                Animal Kingdom
              </h1>
            </div>
          )}
          {pageIndex % 2 === 1 && (
            <>
              <div className="progress-box">
                <div className="progress-label">Progress</div>
                <div className="progress-value">
                  {placedStickers.length} / {STICKERS_DATA.length}
                </div>
              </div>
            </>
          )}
        </header>

        {/* 2. MAIN STICKER GRID */}
        <main className="sticker-main-content">
          {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <div
              className="sticker-slot"
              key={"sticker-item-" + i}
              style={{
                width: STICKERS_DATA[i].width,
                height: STICKERS_DATA[i].height,

                position: "absolute",
                left: STICKERS_DATA[i].x + "%",
                top: STICKERS_DATA[i].y + "%",
                border: "solid 1px red",

                background: `url(${SPRITE_SHEET_URL})`,
                backgroundSize: STICKERS_DATA[i].bgSize + "%",
                backgroundPosition: `${STICKERS_DATA[i].bgX + "px"} ${
                  STICKERS_DATA[i].bgY + "px"
                }`,
              }}
            ></div>
          ))}

          {/* <div className="sticker-grid">
            {STICKERS_DATA.map((sticker) => (
              <StickerSlot
                key={sticker.id}
                sticker={sticker}
                placedId={
                  placedStickers.includes(sticker.id) ? sticker.id : null
                }
              />
            ))}
          </div> */}
        </main>

        {/* FX: Simple Confetti Overlay */}
        {showConfetti && (
          <div className="confetti-overlay">
            <div className="confetti-text">✨ LEGENDARY! ✨</div>
          </div>
        )}
      </div>
    </>
  );
};
